export const toLeadItems = items => items.map(toLeadItem)

export const toLeadItem = item => ({
  value: item.id,
  label: item.name,
  system: item.system,
  code: item.code
})
